import axios from "axios";
import { API_URL, API_KEY } from "./../config/constants";

export const transformSheetData = (data) => {
  if (!data || data.length < 2) return [];

  const headers = data[0]; // First row as headers
  return data.slice(1).map(
    (row) =>
      Object.fromEntries(headers.map((header, i) => [header, row[i] || ""])) // Convert rows into objects
  );
};

export const fetchSheetData = async (sheetId, sheetName) => {
  try {
    const response = await axios.get(
      `${API_URL}/${sheetId}/values/${sheetName}?key=${API_KEY}`
    );
    return transformSheetData(response.data.values) || [];
  } catch (error) {
    console.error("Error fetching data:", error);
    return [];
  }
};
